import { memo } from "react"
import { ItemBackground } from "./item_background"

export const Input = memo<{ title: string; value?: string; onChange?: (value: string) => void; disabled: boolean; placeholder?: string; postfix?: string; autoFocus?: boolean }>(
  ({ title, value, onChange, disabled, placeholder, postfix, autoFocus }) => (
    <>
      <p className=" ml-2"> {title}</p>
      <ItemBackground className={`flex items-center ${disabled ? "" : "!p-0"}`}>
        {disabled ? (
          <>
            {value} {postfix}
          </>
        ) : (
          <input
            className=" min-h-[56px] w-full rounded-lg bg-gray-100 bg-transparent py-[10px] px-4"
            placeholder={placeholder}
            autoFocus={autoFocus}
            value={value || ""}
            onChange={({ target: { value } }) => onChange?.(value)}
          />
        )}
      </ItemBackground>
    </>
  )
)
